import { Language, languages } from '../typings/Language';

export const getLocaleFromUrl = (url: string): Language => {
  const [locale] = url.split('/').filter(Boolean);
  if (locale && !(languages as string[]).includes(locale)) {
    window.location.href = window.location.origin;
  }
  return locale as Language;
};
